"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveElements = void 0;
const moveToSelector = '[data-move-to]';
const moveToAttributeName = 'data-move-to';
const canMoveTo = (moveTo) => {
    return moveToSelector && document.querySelector(moveToSelector) !== null;
};
const moveElements = (moveElement) => {
    const elements = document.querySelectorAll(moveToSelector);
    elements.forEach((element) => {
        const moveToSelector = element.getAttribute(moveToAttributeName);
        if (canMoveTo(moveToSelector)) {
            moveElement(element, document.querySelector(moveToSelector));
            element.removeAttribute(moveToAttributeName);
        }
    });
};
exports.moveElements = moveElements;
